// Modules
import cursor from "./modules/cursorModule.js";
import globalConfiguration from "./modules/globalConfigurationModule.js";
import { getEnabledElement } from "component/toolManager/enabledElements.js";
/**
 * @description 도구/viewport 상태 저장 Store
 */
// let states = {
//   viewportStates: [],
//   tools: []
// };
export let state = {
  // Global
  globalTools: {},
  globalToolChangeHistory: [],
  // Tracking
  enabledElements: [],
  viewportStates: [],
  tools: [],

  isToolLocked: false,
  activeMultiPartTool: null,
  mousePositionImage: {},
  // Settings
  clickProximity: 6,
  touchProximity: 10,
  //handleRadius: 6,
  handleRadius: 5,
  deleteIfHandleOutsideImage: false,
  preventHandleOutsideImage: false,
};

export const getState = {
  tools: () => {
    state.tools.filter((tool) =>
      tool.supportedInteractionTypes.include("Mouse")
    );
  },
  activeToolsforElement: (viewportState) => {
    state.tools.filter(
      (tool) =>
        tool.supportedInteractionTypes.include("Mouse") &&
        tool.isActive === true
    );
  },
};

export const getters = {
  mouseTools: () =>
    state.tools.filter((tool) =>
      tool.supportedInteractionTypes.includes("Mouse")
    ),
  touchTools: () =>
    state.tools.filter((tool) =>
      tool.supportedInteractionTypes.includes("Touch")
    ),
  enabledElementByUID: (enabledElementUID) =>
    state.enabledElements.find(
      (element) => getEnabledElement(element).uuid === enabledElementUID
    ),
};

export const setters = {};

export const modules = {
  cursor,
  globalConfiguration,
};
